/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Maintenance_Labels_AllInputs */



/**
* | output |
* | --- |
* | "All equipment" |
*
* @param {Maintenance_Labels_AllInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const maintenance_labels_all = /** @type {((inputs?: Maintenance_Labels_AllInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Maintenance_Labels_AllInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("All equipment")
	return /** @type {LocalizedString} */ ("Tous les équipements")
});